import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import moIndex from '../../store/index';
import { newValue, newRate } from '@tool/index';

const moCityRate = observable({
  type: 'chart', // chart, table
  isCity: false,
  backupChoose: <any[]>[],
  backupCity: <any[]>[],
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
});

const initCityRate = action((res: any) => {
  const { type } = moCityRate;

  const tempType = localStorage.getItem('indicatorType3') || '';
  if (tempType && (tempType !== type)) moCityRate.type = tempType;
  else localStorage.setItem('indicatorType3', type);

  if (isEmpty(res)) return;

  // console.log('+++ 城市涨薪率 +++ ', res);
  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let labels: any[] = [];
  let years: any[] = [];
  let series: any[] = [];
  let tableLeft: any[] = [];
  let tableRight: any[] = [];

  res.data?.map((item: any) => {
    xData.push(item.city);
    series.push(item.year_data);
    tableLeft.push(item.city);
  });
  tableLeft.unshift('城市');

  series.map((item: any) => {
    item?.map((child: any) => {
      years.push(child.date);
    });
  });
  uniq(years).map((year: any) => {
    let temp: any[] = [];
    series.map((item: any) => {
      item?.map((child: any) => {
        if (child.date === year) temp.push(child.change_rate);
      });
    });
    yData.push({
      name: year,
      data: temp,
    });
  });

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  tableRight.push(uniq(years));
  res.data?.map((item: any) => {
    let temp: any[]= [];
    item.year_data?.map((child: any) => {
      temp.push(newRate(child.change_rate, 1));
    });
    tableRight.push(temp);
  });

  moCityRate.xData = xData;
  moCityRate.yData = yData;
  moCityRate.overview = overview;
  moCityRate.labels = res.total_city_data  || [];
  moCityRate.tableLeft = tableLeft;
  moCityRate.tableRight = tableRight;
});

const changeType = action((type: string) => {
  moCityRate.type = type;
  localStorage.setItem('indicatorType3', type);
});

export default moCityRate;
export {
  initCityRate, changeType,
};
